import './App.css';
import Weather from './components/weather-app/Weather'; // Import the Weather component

function App() {
  return (
    <div className="App">
      <Weather />
    </div>
    );
  }

export default App;
